export let hres87uColumns = () => {
  let indexColumns = [{
    key: 'codempid',
    name: '',
    labelCodapp: 'HRES87UC1',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRES87UC1',
    labelIndex: '40',
    style: 'min-width: 200px;'
  }, {
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES87UC1',
    labelIndex: '45',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codcomp',
    name: '',
    labelCodapp: 'HRES87UC1',
    labelIndex: '130',
    style: 'min-width: 200px;'
  }, {
    key: 'dtereq',
    name: '',
    labelCodapp: 'HRES87UC1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'dteeffec',
    name: '',
    labelCodapp: 'HRES87UC1',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'desc_codexemp',
    name: '',
    labelCodapp: 'HRES87UC1',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'status',
    name: '',
    labelCodapp: 'HRES87UC1',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codappr',
    name: '',
    labelCodapp: 'HRES87UC1',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }, {
    key: 'dteappr',
    name: '',
    labelCodapp: 'HRES87UC1',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'remark',
    name: '',
    labelCodapp: 'HRES87UC1',
    labelIndex: '110',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codempap',
    name: '',
    labelCodapp: 'HRES87UC1',
    labelIndex: '120',
    style: 'min-width: 200px;'
  }]

  let tab3TableColumns = [{
    key: 'codasset',
    name: '',
    labelCodapp: 'HRES87UC5',
    labelIndex: '20',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codasset',
    name: '',
    labelCodapp: 'HRES87UC5',
    labelIndex: '30',
    style: 'min-width: 300px;'
  }, {
    key: 'qtyrcass',
    name: '',
    labelCodapp: 'HRES87UC5',
    labelIndex: '40',
    class: 'align-right',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codunit',
    name: '',
    labelCodapp: 'HRES87UC5',
    labelIndex: '50',
    class: 'align-right',
    style: 'min-width: 120px;'
  }, {
    key: 'dtercass',
    name: '',
    labelCodapp: 'HRES87UC5',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }]

  let tab4TableColumns = [{
    key: 'dtelonst',
    name: '',
    labelCodapp: 'HRES87UC6',
    labelIndex: '20',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'numcont',
    name: '',
    labelCodapp: 'HRES87UC6',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'amtlon',
    name: '',
    labelCodapp: 'HRES87UC6',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'amtnpfin',
    name: '',
    labelCodapp: 'HRES87UC6',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'dteaccls',
    name: '',
    labelCodapp: 'HRES87UC6',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'desc_codlon',
    name: '',
    labelCodapp: 'HRES87UC6',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'numlon',
    name: '',
    labelCodapp: 'HRES87UC6',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }]

  let tab6TableColumns = [{
    key: 'desc_codsco',
    name: '',
    labelCodapp: 'HRES87UC8',
    labelIndex: '30',
    style: 'min-width: 200px;'
  }, {
    key: 'desccomm',
    name: '',
    labelCodapp: 'HRES87UC8',
    labelIndex: '40',
    style: 'min-width: 200px;'
  }, {
    key: 'dtestartf',
    name: '',
    labelCodapp: 'HRES87UC8',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'dtecomm',
    name: '',
    labelCodapp: 'HRES87UC8',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }]
  return {
    en: {
      index: indexColumns,
      detailTab3: tab3TableColumns,
      detailTab4: tab4TableColumns,
      detailTab6: tab6TableColumns
    },
    th: {
      index: indexColumns,
      detailTab3: tab3TableColumns,
      detailTab4: tab4TableColumns,
      detailTab6: tab6TableColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres87u.js